<template>
  <div
    :dependentComputedProps="{
      isSessionPresent,
    }"
  >
    <div
      class="static-pg-header"
      :class="[!isDesktop ? 'plr16 ' : 'd-flex w-auto']"
    >
      <i
        v-if="isOnOffersPage"
        class="hkfi-back dt-hand"
        @click="triggerBack"
      ></i>
      <span class="title">Offers</span>
      <!-- <div class="fs-11 color-slaty pl20" v-if="isCartSelected">
        <span v-if="cartQuantity" class="cart-quantity pr4"
          >{{ cartQuantity }}
          <span>{{ cartQuantity > 1 ? "Items" : "Item" }}</span></span
        >
        <span v-if="cartQuantity && displayNetPrice" class="color-border"
          >|</span
        >
        <span class="cart-quantity pl4" v-if="displayNetPrice"
          ><span class="rs" v-if="Number(displayNetPrice) > 0">Rs.</span
          >{{ displayNetPrice }}</span
        >
      </div> -->
      <i
        v-if="isDesktop && !isOnOffersPage"
        @click.stop="closeOffersWrapper($event)"
        class="hkfi-close dt-mla-auto hand fs-22"
      ></i>
    </div>
    <div v-if="!showShimnmer && !isLoading">
      <div class="pb12 plr16 dt-pc" v-if="showCouponInputBar">
        <!-- <h1 class="fs-14 bold">Offers for You</h1>
          <p class="fs-12 color-grey-light">
            Enter a coupon and add items to your cart
          </p> -->
        <div class="searchblock">
          <input
            class="enter-coupon"
            id="searchQueryInput"
            type="text"
            name="searchQueryInput"
            placeholder="Enter coupon code"
            v-on:keyup="enableApply"
            :class="{ 'color-error': offerFailedMsg }"
          />
          <div v-if="isApplyEnabled" class="d-flex borderRight">
            <img
              :src="staticImgBaseUrl + '/images/global/offer-cross.svg'"
              @click="clearSearchInput"
            />
          </div>
          <button
            :class="[
              isApplyEnabled && !offerFailedMsg
                ? 'enabledButtonSearchOffer'
                : 'disabledButtonSearchOffer',
            ]"
            @click="triggerOfferAppliedModal($event)"
          >
            Apply
          </button>
        </div>
        <p
          v-if="offerFailedMsg && failedOfferPromo === manualOffer"
          class="fs-11 color-error"
        >
          {{ offerFailedMsg }}
        </p>
      </div>
      <div :class="{ 'offer-listing-modal': isDesktop }">
        <div class="list-lft" :class="[!isDesktop ? 'plr16' : '']">
          <!-- All Coupons  -->
          <div
            v-if="welcomeOffers?.length"
            class="pb24 dt-plr24"
            :class="{ pb70: showBottomNav }"
          >
            <div
              v-for="(offerList, index2) in welcomeOffers"
              :key="offerList?.category"
              class="aligncenter pt12"
            >
              <div class="fs-16 fw-800 d-flex align-items-center color-slaty">
                {{ offerList?.displayTitle
                }}<img
                  :src="offerStroke"
                  alt="offer-title-strike"
                  class="pl5"
                />
              </div>
              <div
                v-for="(item, index) in offerList?.data"
                :key="item?.campaignId"
                class="aligncenter pt12"
              >
                <offer-listing-card
                  :data-index="index"
                  :data-promo-code="item.couponCode"
                  :data-title="item.metaData?.name"
                  :data-display-message="item.metaData?.shortSavingsMessage"
                  :data-text="item.metaData?.description"
                  :data-action="
                    appliedOfferPromo == item.couponCode ? 'Remove' : 'Apply'
                  "
                  :data-is-offer-applied="appliedOfferPromo == item.couponCode"
                  :data-error-msg="item?.messages?.[0]?.message || false"
                  :data-item-tnc="item.campaignId"
                  :data-selected-offer="selectedOffer?.couponCode"
                  :data-section-position="index2 + 1"
                  :data-is-applicable="item?.applicable"
                  :data-offer-icon="
                    getOfferIcon(item, offerList?.category, index)
                  "
                  :data-offer-background-top="
                    getOfferBackgroundTop(item, offerList?.category, index)
                  "
                  :data-offer-background-bottom="
                    getOfferBackgroundBottom(item, offerList?.category, index)
                  "
                  :data-theme="getTheme(item, offerList?.category, index)"
                  :data-bottom-msg="getBottomMsg(item)"
                  :data-expiry-timer="item?.expiryTimer"
                  :data-from-cart="false"
                  :data-heading="offerList?.displayTitle"
                >
                </offer-listing-card>
                <p
                  v-if="offerFailedMsg && failedOfferPromo == item.couponCode"
                  class="fs-11 color-error"
                >
                  {{ offerFailedMsg }}
                </p>
              </div>
            </div>
          </div>

          <!-- @TODO:  payment offers does not exist in hongs for now, implemented as per dominos , new api for payment offers has been integrated- with stores 
        <div v-if="paymentOffers?.length" class="pb24 dt-plr24">
          <div class="fs-16 bold">Payment Offers</div>
          <div
            v-for="(item, index) in paymentOffers"
            :key="item?.id"
            class="aligncenter pt12"
          >
            <offer-listing-card
              :data-index="index"
              :data-logo="item.iconUrl"
              :data-title="item.metaData.name"
              :data-display-message="item.metaData.description"
              :data-text="item.metaData?.savingsMessage"
              :data-offer-list="item.offerlist"
              :data-expiry-date="item?.expiryDate"
              :data-action="'Apply'"
              :data-offer-type="'Payment Offer'"
            >
            </offer-listing-card>
          </div>
        </div> -->
        </div>
        <div class="list-rgt" :class="[!isDesktop ? 'plr16' : '']">
          <!-- for desktop view - showing offer details content without popup -->
          <offer-details-flat-content
            v-if="isDesktop"
            :data-title="selectedOffer?.metaData?.name"
            :data-description="selectedOffer?.metaData?.description"
            :data-coupon-code="selectedOffer?.couponCode"
            :data-item-tnc="selectedOffer?.campaignId"
            :data-is-applicable="selectedOffer?.applicable"
            :data-expiry-date="''"
          ></offer-details-flat-content>
          <!-- for pwa view - offer details popup -->
          <offer-details-popup
            v-if="!isDesktop && offerDetailsModalFlag"
            :data-title="selectedOffer?.metaData?.name"
            :data-description="selectedOffer?.metaData?.description"
            :data-coupon-code="selectedOffer?.couponCode"
            :data-savings-msg="selectedOffer?.metaData?.savingsMessage"
            :data-is-applicable="selectedOffer?.applicable"
            :data-expiry-date="''"
          ></offer-details-popup>
        </div>
      </div>
      <div class="pt140 pb80" v-if="!isLoading && !welcomeOffers.length">
        <div class="d-flex justify-content-center">
          <img :src="noOffersImage" class="static-no-offers-image" />
        </div>
        <div class="fs-12 tc color-grey-light">
          {{ noOffersText }}
        </div>
      </div>
    </div>
    <offer-listing-page-shimmer v-else></offer-listing-page-shimmer>
  </div>
</template>
<script>
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import {
  keyMapsAction,
  keyMapsGetter,
  keyMapsMutation,
} from "../helpers/storeKeys";
import OfferListingPageShimmer from "./OfferListingPageShimmer.vue";
import OfferListingCard from "./OfferListingCard.vue";
import { EVENT_OFFER_SCREEN } from "../helpers/analyticsEvents";

export default {
  components: {
    OfferDetailsPopup: defineAsyncComponent(
      () => import("./OfferDetailsPopup.vue"),
    ),
    OfferDetailsFlatContent: defineAsyncComponent(
      () => import("./OfferDetailsFlatContent.vue"),
    ),
    OfferListingPageShimmer,
    OfferListingCard,
  },
  name: "OffersListingPage",
  props: ["moduleProps"],
  data() {
    return {
      clientPlatform,
      isApplyEnabled: false,
      parsedResults: [],
      staticImgBaseUrl,
      modulePropsData: {},
      offerBackgrounds: {},
      showShimnmer: true,
      inputAttemptFlag: true,
      noOffersImage: "",
      noOffersText: "",
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.offerBackgrounds = Utility.tryJsonParse(
      this.modulePropsData?.offerBackgrounds,
    );
    this.noOffersImage = this.modulePropsData?.noOffersImage;
    this.noOffersText = this.modulePropsData?.noOffersText;
    document.body.classList.remove("body-stop-scroll-mobile");
    this.$store.commit(
      keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO,
      LocalStorageFunc.getCouponCode()?.code,
    );
    this.parsedResults = Utility.getCartDataInMenuServiceFormat(
      LocalStorageFunc.getCart(),
    );
    this.processResultDataForStore(this.parsedResults);
    setTimeout(() => {
      this.showShimnmer = false;
    }, 5000);
  },
  methods: {
    processResultDataForStore(data) {
      this.$store.commit(keyMapsMutation.UPDATE_PRODUCTS_IN_STORE, data);
      this.$store.commit(keyMapsMutation.LOAD_CART_FROM_STORAGE_SERVICE, {});
    },
    triggerBack(e) {
      LocalStorageFunc.setOffersFromTab(false);
      if (this.isCartSelected) {
        LocalStorageFunc.setPrevUrl("");
        Utility.sendToCartScreen();
      } else {
        Utility.redirectToHomeOrRedirectUrl();
      }
    },
    enableApply() {
      let i = document.getElementById("searchQueryInput");
      if (this.offerFailedMsg) {
        this.$store.commit(keyMapsMutation.UPDATE_OFFER_FAILED_MSG, "");
      }
      if (i.value.length > 0) {
        this.isApplyEnabled = true;
      } else {
        this.isApplyEnabled = false;
      }
      const cartReponse = LocalStorageFunc.getCartResponse();
      if (i.value.length > 2 && this.inputAttemptFlag) {
        EVENT_OFFER_SCREEN({
          eventAction: "coupon input attempted",
          sectionName: "manual input",
          catergory: "coupon application",
          cartId: LocalStorageFunc.cartId(),
          paymentMethod: "",
          discount: cartReponse?.calculations.find(
            (res) => res.key == "discount",
          )?.value,
          subTotal: cartReponse?.calculations.find(
            (res) => res.key == "sub_total",
          )?.value,
          itemTotal:
            cartReponse?.calculations.find((res) => res.key == "sub_total")
              ?.value -
            cartReponse?.calculations?.find((res) => res.key == "discount")
              ?.value +
            cartReponse?.calculations?.find(
              (res) => res.key == "tax_and_charges",
            )?.value,
          coupon: i?.value,
          deliveryCharge: cartReponse?.calculations?.find(
            (res) => res.key == "tax_and_charges",
          )?.value,
          paymentMethodSaved: "No",
        });
        this.inputAttemptFlag = false;
      }
    },

    triggerOfferAppliedModal(event) {
      if (this.isApplyEnabled && !this.offerFailedMsg) {
        let couponCode = document.getElementById("searchQueryInput").value;
        if (this.isCartSelected) {
          event?.stopPropagation();
          this.$store.dispatch(keyMapsAction.APPLY_OFFER_API, {
            couponCode: couponCode,
            source: "MANUAL",
          });
        } else {
          this.$store.commit(
            keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO,
            couponCode,
          );
          const cartReponse = LocalStorageFunc.getCartResponse();
          EVENT_OFFER_SCREEN({
            eventAction: "coupon applied",
            sectionName: "manual input",
            category: "coupon application",
            subcategory: "coupon application failure",
            cartId: LocalStorageFunc.cartId(),
            failureReason: errMsg,
            couponDetail: "",
            paymentMethod: "",
            discount: cartReponse?.calculations.find(
              (res) => res.key == "discount",
            )?.value,
            subTotal: cartReponse?.calculations.find(
              (res) => res.key == "sub_total",
            )?.value,
            itemTotal:
              cartReponse?.calculations.find((res) => res.key == "sub_total")
                ?.value -
              cartReponse?.calculations?.find((res) => res.key == "discount")
                ?.value +
              cartReponse?.calculations?.find(
                (res) => res.key == "tax_and_charges",
              )?.value,
            coupon: i?.value,
            deliveryCharge: cartReponse?.calculations?.find(
              (res) => res.key == "tax_and_charges",
            )?.value,
            paymentMethodSaved: "No",
          });
          LocalStorageFunc.updateCouponCode(couponCode);
          this.$store.commit(keyMapsMutation.UPDATE_IS_HAMBURGER, false);
          this.$store.commit(keyMapsMutation.UPDATE_VIEW_ALL_OFFERS, false);
          LocalStorageFunc.setOfferAppliedModal(true);
          Utility.redirectToHomeOrRedirectUrl();
        }

        if (this.offerFailedMsg) {
          setTimeout(() => {
            this.$store.commit(keyMapsMutation.UPDATE_OFFER_FAILED_MSG, "");
          }, 1000);
        } else {
          // this.clearSearchInput();
        }
      }
    },
    closeAppliedModal(event) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, false);
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
        false,
      );
    },

    closeOfferDetailsModal(source) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
        false,
      );
      if (window.location.href?.includes("/offers")) {
        Utility.updateOfferUrl();
      }
    },
    clearSearchInput() {
      document.getElementById("searchQueryInput").value = "";
      this.isApplyEnabled = false;
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_FAILED_MSG, "");
    },
    closeOffersWrapper() {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_INIT_OFFER_LISTING_WRAPPER,
        false,
      );
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_FAILED_MSG, "");
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_OFFER, {});
    },
    getOfferIcon(item, type, index) {
      if (!item?.applicable) {
        return this.modulePropsData?.disabledOfferIcon;
      } else if (!item?.expiryTimer?.endTime) {
        if (this.offerBackgrounds?.[type]?.length === 1) {
          return this.offerBackgrounds?.[type]?.[0]?.iconPercent;
        } else {
          return this.offerBackgrounds?.[type]?.[
            index % this.modulePropsData?.couponCount
          ]?.iconPercent;
        }
      } else {
        if (this.offerBackgrounds?.[type]?.length === 1) {
          return this.offerBackgrounds?.[type]?.[0]?.icon;
        } else {
          return this.offerBackgrounds?.[type]?.[
            index % this.modulePropsData?.couponCount
          ]?.icon;
        }
      }
    },
    getOfferBackgroundTop(item, type, index) {
      if (!item.applicable) {
        return this.modulePropsData?.disabledOfferBackgroundTop;
      } else {
        if (this.offerBackgrounds?.[type]?.length === 1) {
          return this.offerBackgrounds?.[type]?.[0]?.backgroundTop;
        } else {
          return this.offerBackgrounds?.[type]?.[
            index % this.modulePropsData?.couponCount
          ]?.backgroundTop;
        }
      }
    },
    getOfferBackgroundBottom(item, type, index) {
      if (!item.applicable) {
        return this.modulePropsData?.disabledOfferBackgroundBottom;
      } else {
        if (this.offerBackgrounds?.[type]?.length === 1) {
          return this.offerBackgrounds?.[type]?.[0]?.backgroundBottom;
        } else {
          return this.offerBackgrounds?.[type]?.[
            index % this.modulePropsData?.couponCount
          ]?.backgroundBottom;
        }
      }
    },
    getTheme(item, type, index) {
      if (!item.applicable) {
        return "";
      } else {
        if (this.offerBackgrounds?.[type]?.length === 1) {
          return this.offerBackgrounds?.[type]?.[0]?.index;
        } else {
          return this.offerBackgrounds?.[type]?.[
            index % this.modulePropsData?.couponCount
          ]?.index;
        }
      }
    },
    getBottomMsg(offersData) {
      // Check if offer is applicable
      if (offersData.applicable) {
        // Check if there's an expiry timer
        if (
          offersData.expiryTimer &&
          offersData.expiryTimer.endTime !== 0 &&
          offersData.expiryTimer.endTime > Date.now() &&
          offersData.expiryTimer.showTimerBefore <= Date.now()
        ) {
          if (
            offersData.labelType &&
            offersData.labelType === "General_Milestone" &&
            offersData.offerOptions
          ) {
            // MilestoneCouponBar logic
            return ""; //Todo
          } else {
            return `Coupon expires in
              ${Utility.formatTimestampOffer(
                offersData.expiryTimer?.endTime - Date.now(),
              )}`;
          }
        }

        // General Milestone without expiryTimer
        if (
          offersData.labelType &&
          offersData.labelType === "General_Milestone" &&
          offersData.offerOptions
        ) {
          return ""; //Todo
        }

        // Payment offer with message
        if (
          offersData.paymentOffersMetadata?.paymentId &&
          offersData.messages &&
          offersData.messages[0]?.messageType &&
          offersData.messages[0]?.messageType.toLowerCase() === "nudge" &&
          offersData.messages[0]?.message
        ) {
          return offersData.messages[0].message;
        }
      } else if (
        !offersData.applicable &&
        offersData.messages &&
        offersData.messages[0]?.messageType &&
        offersData.messages[0]?.messageType.toLowerCase() === "error" &&
        offersData.messages[0]?.message
      ) {
        return offersData.messages[0].message;
      }

      return this.modulePropsData?.staticOfferCardText;
    },
  },
  computed: {
    isDesktop() {
      return Utility.isDesktop();
    },
    welcomeOffers() {
      // return [];
      return this.$store.state.Offers.welcomeOffers;
    },
    offerFailedMsg() {
      return this.$store.state.Offers.offerFailedMsg;
    },
    paymentOffers() {
      return this.$store.state.PaymentOffers.paymentOffers;
    },
    selectedPaymentOfferTnc() {
      return this.$store.state.PaymentOffers.selectedPaymentOfferTnc;
    },
    topCouponIndex() {
      return this.$store.state.Offers.topCouponIndex;
    },
    offerDetailsModalFlag() {
      return this.$store.state.Offers.offerDetailsModalFlag;
    },
    selectedOfferTnc() {
      return this.$store.state.Offers.selectedOfferTnc;
    },
    selectedOffer() {
      return Utility.isDesktop()
        ? this.$store.state.Offers.selectedOffer &&
          Object.keys(this.$store.state.Offers.selectedOffer).length
          ? this.$store.state.Offers.selectedOffer
          : this.appliedOfferPromo
            ? this.offersList.find(
                (i) => i.couponCode == this.appliedOfferPromo,
              )
            : this.welcomeOffers[0]?.data[0]
        : this.$store.state.Offers.selectedOffer;
    },
    isCartSelected() {
      return LocalStorageFunc.getPrevUrl().includes("/cart");
    },
    isOnOffersPage() {
      return Utility.isCurrentlyAtUrl("/offers");
    },
    appliedOfferPromo() {
      return this.$store.state.Offers.appliedOfferPromo;
    },
    failedOfferPromo() {
      return this.$store.state.Offers.failedOfferPromo;
    },
    manualOffer() {
      return this.$store.state.Offers.manualOffer;
    },
    offerStroke() {
      return this.modulePropsData?.offerStroke;
    },
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (isSessionP) {
        this.$store.dispatch(
          keyMapsAction.WELCOME_OFFER_API,
          this.isCartSelected ? "" : "deals_and_offers",
        );
      }
      return isSessionP;
    },
    isLoading() {
      return this.$store.state.Loader.isLoading;
    },
    offersList() {
      return this.$store.state.Offers.offersList;
    },
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
    displayNetPrice() {
      return this.$store.state.Global.displayNetPrice;
    },
    showCouponInputBar() {
      return this.isCartSelected
        ? this.modulePropsData?.showCouponInputBar
        : false;
    },
    showBottomNav() {
      return LocalStorageFunc.getOffersFromTab() && this.welcomeOffers?.length;
    },
  },
};
</script>
<style></style>
